import { action } from 'easy-peasy';
import { IActionSetActTeams } from '../types';

const setActTeams: IActionSetActTeams = action((state, payload) => {
  const { items, pagination } = payload;

  state.list = items;

  if (pagination) {
    state.pagination.total = pagination.total;
    state.pagination.pageNumber = pagination.pageNumber;
    state.pagination.pageSize = pagination.pageSize;
  }
});

export default setActTeams;
